import { apiSlice } from '../apiSlice';

export type ResourceResponse = {
  user: string;
  userResourceRefs: any[];
};
interface userMeta {
  name: string;
  lastLogin: string;
  avatar: string;
  uuid: string;
}
interface userResponse {
  role: string;
  meta: userMeta;
  wjec: boolean;
  created: string;
  SK: string;
  PK: string;
  email: string;
  modified: string;
  emailHash: string;
}

export interface User {
  PK: string;
  SK: string;
  role: string;
  wjec: boolean;
  email: string;
  emailHash: string;
  meta: userMeta;
  termsConditions?: string;
}

/** API Endpoints related to User(s) */
export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    /** 
    * updateUser mutation (POST)
    * @param {User} user - the user form data.
    * @returns {User} the updated user.
    */
    updateUser: build.mutation<User, {user:User}>({
      query: (data) => {
        return {
          url: `user/update`,
          method: 'POST',
          body: data
        }
      },
      invalidatesTags: ['User']

    }),

    /** 
    * getUserMeta query (GET)
    * @description gets the current user's metadata
    * @returns {userMeta & {emailHash: string}} the fetched user.
    */
    getUserMeta: build.query<userMeta & {emailHash: string}, void>({
      query: () => `user/get`,
      transformResponse(res:userResponse, meta, arg ) {
        return { ...res.meta, emailHash: res.emailHash }
      },
      providesTags: ['User']
    }),

    /** 
    * getUserById query (GET)
    * @description gets the user from specified `id`
    * @param {string} userId - the user's id.
    * @returns {userResponse} the fetched user.
    */
    getUserById: build.query<userResponse, {userId: string}>({
      query: ({userId}) => `user/get/${userId}`,
      providesTags:['User']
    }),

    /** 
    * getUser query (GET)
    * @description gets the current user
    * @returns {User} the fetched user.
    */
    getUser: build.query<User, void>({
      query: () => `user/get`,
      providesTags:['User']
    })
  })
});

export const {useGetUserByIdQuery, useGetUserMetaQuery, useGetUserQuery, useUpdateUserMutation} =
  userApiSlice;
